import React, { useContext, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import AdvancedSearchDropdown from '../../../components/dropdown';

import { AdvancedSearchShipmentContext } from '../../context';
import { id } from '../../../../filters/options/delivery-status/delivery-status-as-collection';
import { deliveryStatusOptions } from '../../../../filters/options/delivery-status/options';
import messages from '../messages';

import baseStyle from '../../../style.module.less';
import { isOperator } from '../../../../filters/operators/collection';

const defaultOption = {
  id: 'DEFAULT_OPTION',
  apiKey: 'DEFAULT_OPTION',
  component: <FormattedMessage {...messages.selectOne} />,
};

const allOptions = [defaultOption, ...deliveryStatusOptions];

const DeliveryStatusFilter = () => {
  const { filters, updateFilter, clearFilter } = useContext(AdvancedSearchShipmentContext);

  const { value: [value = defaultOption.apiKey] = [] } = filters.find((filter) => filter.id === id) || {};
  const selectedDeliveryStatus = allOptions.find((opt) => opt.apiKey === value) || {};

  const onOptionSelected = useCallback(
    (option) => {
      if (option.id === defaultOption.id) {
        clearFilter(id);
        return;
      }
      updateFilter(id, [option.apiKey], isOperator);
    },
    [updateFilter, clearFilter],
  );

  return (
    <span className={baseStyle.filterInput}>
      <label className={baseStyle.filterLabel}>
        <FormattedMessage {...messages.deliveryStatus} />
      </label>
      <AdvancedSearchDropdown onOptionSelected={onOptionSelected} options={allOptions} selectedId={selectedDeliveryStatus.id} />
    </span>
  );
};

export default DeliveryStatusFilter;
